var t = /* @__PURE__ */ ((e) => (e.medium = "medium", e.small = "small", e.tiny = "tiny", e))(t || {}), n = /* @__PURE__ */ ((e) => (e.inline = "inline", e.standalone = "standalone", e))(n || {}), l = /* @__PURE__ */ ((e) => (e.left = "left", e.right = "right", e))(l || {}), r = /* @__PURE__ */ ((e) => (e.default = "default", e.strong = "strong", e))(r || {}), a = /* @__PURE__ */ ((e) => (e.default = "default", e.light = "light", e))(a || {});
function u(e) {
  const i = ["link-interim"];
  if (e.disabled && i.push("link-interim-disabled"), e.behavior === "standalone")
    switch (i.push("link-interim-standalone"), e.size) {
      case "tiny":
        i.push("link-interim-xs");
        break;
      case "small":
        i.push("link-interim-sm");
        break;
      case "medium":
      default:
        i.push("link-interim-md");
        break;
    }
  return e.variant === "strong" && i.push("link-interim-strong"), e.variantColor === "light" && i.push("link-interim-light"), e.underlined && i.push("link-interim-underlined"), i.join(" ");
}
export {
  n as ELinkBehaviors,
  l as ELinkIconPositions,
  t as ELinkSizes,
  a as ELinkVariantColors,
  r as ELinkVariants,
  u as getLinkStyleClasses
};
